<script setup lang="ts">
import { onClickOutside } from "@vueuse/core";
import useEventStore from "~/stores/event";

const { t } = useI18n();
const eventStore = useEventStore();
const canPlayTag = ref(true);
const playAllRef = ref(null);
const isPlayAllModeActive = ref(false);
const activeTagIndex = ref(-1);
const activeTagEndTime = ref(0);

const tags = computed(() => [...eventStore.tags.data.values()].sort((a, b) => a.startTime - b.startTime));
const playingTime = computed(() => eventStore.playerState?.currentTime || 0);
const isPlayerPlaying = computed(() => eventStore.playerState?.playing);

const togglePlayAllMode = () => {
  if (!isPlayAllModeActive.value) {
    isPlayAllModeActive.value = true;
    activeTagIndex.value = 0;
    activeTagEndTime.value = tags.value[activeTagIndex.value].endTime;
    eventStore.player?.currentTime(tags.value[activeTagIndex.value].startTime);
    return;
  }

  isPlayAllModeActive.value = false;
};

function playAll() {
  if (!isPlayAllModeActive.value)
    return;

  const tag = tags.value[activeTagIndex.value];

  if (canPlayTag.value) {
    eventStore.player?.currentTime(tag.startTime);
    canPlayTag.value = false;
  }

  if (playingTime.value >= activeTagEndTime.value) {
    canPlayTag.value = true;
    activeTagIndex.value++;

    if (activeTagIndex.value < tags.value.length) {
      const nextTag = tags.value[activeTagIndex.value];
      activeTagEndTime.value = nextTag.endTime;
    } else {
      isPlayAllModeActive.value = false;
    }
  }

  if (!isPlayerPlaying.value)
    eventStore.player?.play();
}

const tooltipTitle = computed(() => isPlayAllModeActive.value
  ? t("pages.events.tabs.event_tags.pause_all_btn")
  : t("pages.events.tabs.event_tags.play_all_btn"));

watch(playingTime, playAll);
onClickOutside(playAllRef, () => isPlayAllModeActive.value = false);
</script>

<template>
  <div ref="playAllRef">
    <BaseButton v-tooltip.bottom="tooltipTitle" name="play-all" type="icon" @click="togglePlayAllMode">
      <IconPauseAll v-if="isPlayAllModeActive" class="cursor-pointer" fill="var(--base-icon-color)" />
      <IconPlayAll v-else fill="var(--base-icon-color)" class="cursor-pointer" />
    </BaseButton>
  </div>
</template>
